import React, { useState, useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';

const AttendanceFilter = (props) => {
    const {
        filterText, onTextFilterChange,
        onBranchFilterChange, 
        onPackageFilterChange,
        onClassFilterChange,
        onYearIntakeChange,
        onDateChange,
        onAttendanceChange,
    } = props;

    const currentYear = new Date().getFullYear();
    const token = localStorage.getItem('auth_token');
    const headersConfig = {
        headers: { 'Authorization': `Bearer ${token}` }
    };

    const [fetchedBranches, setFetchedBranches] = useState([]);
    const [fetchedPackages, setFetchedPackages] = useState([]);
    const [fetchedClasses, setFetchedClasses] = useState([]);
    const years = [currentYear - 1, currentYear, currentYear + 1];

    const initialBranchId = fetchedBranches.length ? fetchedBranches[0].branch_id : null;

    const [branchId, setBranchId] = useState(initialBranchId);
    const [packageId, setPackageId] = useState('');
    const [catId, setCatId] = useState('');
    const [yearIntake, setYearIntake] = useState(currentYear);
    const [attendanceFilter, setAttendanceFilter] = useState('All');
    const [selectedDate, setSelectedDate] = useState(new Date());

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/react/getBranches`, headersConfig)
        .then(({ data }) => {
            if (Array.isArray(data.data)) {
                setFetchedBranches(data.data);
                if (data.data.length) {
                    setBranchId(data.data[0].branch_id);
                }
            }
        })
        .catch(error => console.error("Error fetching branches:", error.message));
    }, [yearIntake]);

    useEffect(() => {
        if (branchId) {
            axios.get(`${process.env.REACT_APP_API_URL}/api/react/getPackages?branch_id=${branchId}`, headersConfig)
            .then(({ data }) => {
                if (Array.isArray(data.data)) {
                    setFetchedPackages(data.data);
                }
            })
            .catch(error => console.error("Error fetching packages:", error.message));
        } else {
            setFetchedPackages([]);
        }
    }, [branchId]);    

    useEffect(() => {
        if (branchId && packageId) {
            axios.get(`${process.env.REACT_APP_API_URL}/api/react/getClasses?branch_id=${branchId}&package_id=${packageId}`, headersConfig)
            .then(({ data }) => {
                if (Array.isArray(data.data)) {
                    setFetchedClasses(data.data);
                }
            })
            .catch(error => console.error("Error fetching classes:", error.message));
        }
    }, [branchId, packageId]);

    useEffect(() => {
        onBranchFilterChange(branchId);
        onPackageFilterChange(packageId);
        onClassFilterChange(catId);
        onYearIntakeChange(yearIntake);
    }, [branchId, packageId, catId, yearIntake]);

    return (
        <Container fluid={true}>
            <Row>
                <Col sm="6" xl="3">
                    <label htmlFor="branches">Student Name</label>
                    <div className="mb-3">
                        <input
                            className="form-control form-control"
                            id="search"
                            type="text"
                            placeholder="Filter By Name"
                            aria-label="Search Input"
                            value={filterText}
                            onChange={e => onTextFilterChange(e.target.value)}
                        />
                    </div>

                    <label htmlFor="packages">Packages</label>
                    <Select
                        isClearable
                        value={{ value: packageId, label: fetchedPackages.find(pkg => pkg.package_id === packageId)?.name }}
                        options={fetchedPackages.map(pkg => ({
                            value: pkg.package_id,
                            label: pkg.name
                        }))}
                        className="js-example-basic-single"
                        onChange={selectedOption => {
                            setPackageId(selectedOption ? selectedOption.value : null);
                            setCatId('');
                        }}                        
                    />
                </Col>
                <Col sm="6" xl="3">
                    <label htmlFor="year-intake">Year Intake</label>
                    <Select
                        defaultValue={{ value: currentYear, label: currentYear }}
                        options={years.map(year => ({
                            value: year,
                            label: year
                        }))}
                        className="js-example-basic-single mb-3"
                        onChange={selectedOption => {
                            setYearIntake(selectedOption.value);
                            onYearIntakeChange(selectedOption.value);
                            setBranchId(fetchedBranches[0]?.branch_id || null);
                            setPackageId('');
                            setCatId('');
                        }}
                    />

                    <label htmlFor="classes">Classes</label>
                    <Select
                        isClearable
                        value={{ value: catId, label: fetchedClasses.find(classItem => classItem.cat_id === catId)?.name }}
                        options={fetchedClasses.map(classItem => ({
                            value: classItem.cat_id,
                            label: classItem.name
                        }))}
                        className="js-example-basic-single"
                        onChange={selectedOption => {
                            setCatId(selectedOption ? selectedOption.value : null);
                        }}
                    />
                </Col>
                <Col sm="6" xl="3">
                    <label htmlFor="branches">Branches</label>
                    <Select
                        isClearable
                        value={{ value: branchId, label: fetchedBranches.find(branch => branch.branch_id === branchId)?.code }}
                        options={fetchedBranches.map(branch => ({
                            value: branch.branch_id,
                            label: branch.code
                        }))}
                        className="js-example-basic-single mb-3"
                        onChange={selectedOption => {
                            setBranchId(selectedOption ? selectedOption.value : null);
                            setPackageId('');
                            setCatId('');
                        }}
                    />

                    <label htmlFor="attendance">Attendance</label>
                    <Select
                        value={{ value: attendanceFilter, label: attendanceFilter ? attendanceFilter.charAt(0).toUpperCase() + attendanceFilter.slice(1) : 'All' }}
                        options={[
                            { value: null, label: 'All' },
                            { value: 'attend', label: 'Present' },
                            { value: 'absent', label: 'Absent' }
                        ]}
                        className="js-example-basic-single"
                        onChange={selectedOption => {
                            setAttendanceFilter(selectedOption.value);
                            onAttendanceChange(selectedOption.value);
                        }}
                    />
                </Col>
                <Col sm="6" xl="3">
                    <label htmlFor="datePicker">Date</label>
                    <div className="datepicker-here" data-language="en">
                        <DatePicker
                            className="form-control digits"
                            selected={selectedDate}
                            onChange={date => {
                                setSelectedDate(date);
                                onDateChange(date);
                            }}  
                            inline                      
                        />
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default AttendanceFilter;